import {
  SHOW_FEEDBACK_BANNER,
  HIDE_FEEDBACK_BANNER,
} from "../Actions/FeedbackBannerActions";

const initialState = {
  show: false,
  message: "",
  variant: "info", // default to Bootstrap's 'info'
};

const FeedbackBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_FEEDBACK_BANNER:
      return {
        ...state,
        show: true,
        message: action.payload.message,
        variant: action.payload.variant || "info",
      };
    case HIDE_FEEDBACK_BANNER:
      return {
        ...state,
        show: false,
        message: "",
        variant: "info",
      };
    default:
      return state;
  }
};

export default FeedbackBannerReducer;
